import { EventEmitter } from 'events';

export default class ConfirmationModel extends EventEmitter {
    public confirm(message: string) {
        this.emit('confirm', message);

        return new Promise((resolve, reject) => {
            this.once('confirmed', () => resolve(true));
            this.once('rejected', () => resolve(false));
        });
    }

    public confirmed() {
        this.emit('confirmed');
    }

    public rejected() {
        this.emit('rejected');
    }
}
